module.exports = __webpack_public_path__ + "static/media/4.3_preview.02adf527.png";